export const text = {
  common: {
    mc: 'สัญญาผู้ขาย',
    ts: 'ข้อตกลงการให้บริการ',
    all: 'ทั้งหมด',
  },
  login: {
    welcome: 'ยินดีต้อนรับสู่ศูนย์ผู้ขายของ Atome',
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    forget: 'ลืมรหัสผ่าน?',
    login: 'ลงชื่อเข้าใช้',
    incorrect: `ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง หากลืมรหัสผ่าน คุณสามารถตั้งค่ารหัสผ่านได้ใหม่โดยคลิกที่ ‘Forgot Password' ที่ด้านล่าง`,
    placeholder: 'พิมพ์ชื่อผู้ใช้ / อีเมลของคุณ',
    placeholder2: 'พิมพ์รหัสผ่านของคุณ',
  },
  profile: {
    setting: 'การตั้งค่าบัญชี',
    profile: 'โพรไฟล์',
    company: 'บริษัท',
    address: 'ที่อยู่',
    phone: 'โทรศัพท์',
    email: 'อีเมล',
    createTime: 'เวลาที่สร้าง',
    subscription: 'การลงทะเบียน',
    subscribe: 'การลงทะเบียน',
    editSubscription: 'แก้ไขการสมัครสมาชิก',
    dailyPayoutReport: 'รายงานการจ่ายเงินรายวัน',
    dailyTransReport: 'รายงานธุรกรรมรายวัน',
    changePwd: 'เปลี่ยนรหัสผ่าน',
    logout: 'ลงชื่อออก',
    username: 'ชื่อผู้ใช้',
    outlet: 'ร้านค้า',
    password: 'รหัสผ่าน',
    language: 'ภาษา',
  },
  roleList: {
    roleMana: 'การจัดการตำแหน่ง',
    addRole: 'เพิ่มตำแหน่ง',
    roleName: 'ชื่อตำแหน่ง',
    time: 'เวลาที่สร้าง',
    action: 'การดำเนินการ',
    confirmDel: 'ยืนยันการลบตำแหน่ง ',
    delete: 'ลบ',
    deleteTip: 'แน่ใจหรือไม่ว่าต้องการลบตำแหน่ง {{roleName}}? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    desc: 'คำอธิบาย',
    roleDetail: 'รายละเอียดตำแหน่ง',
    cancel: 'ยกเลิก',
    edit: 'แก้ไข',
    success: 'ลบเสร็จเรียบร้อย',
    failed: 'ไม่สามารถลบตำแหน่งนี้ กรุณาลองอีกครั้งในภายหลัง',
  },
  role: {
    roleName: 'ชื่อตำแหน่ง',
    permissions: 'การอนุญาต',
    desc: 'คำอธิบาย',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    addRole: 'เพิ่มตำแหน่ง',
    editRole: 'แก้ไขตำแหน่ง',
    required1: `ต้องมีชื่อตำแหน่ง`,
    required2: `ต้องมีการอนุญาต`,
    select: 'กรุณาเลือก',
    success: `คุณได้แก้ไขตำแหน่งเรียบร้อยแล้ว`,
    success2: `คุณสร้างตำแหน่งใหม่เรียบร้อยแล้ว`,
  },
  userList: {
    userMana: 'การจัดการผู้ใช้งาน',
    addUser: 'เพิ่มผู้ใช้งาน',
    role: 'บทบาท',
    userName: 'ชื่อผู้ใช้',
    search: 'ค้นหา',
    email: 'อีเมล',
    time: 'เวลาที่สร้าง',
    action: 'การดำเนินการ',
    edit: 'แก้ไข',
    del: 'ลบ',
    userDetail: 'รายละเอียดผู้ใช้งาน',
    delTip: 'แน่ใจหรือไม่ว่าต้องการลยผู้ใช้นี้ {{userName}}? การดำเนินการนี้ไม่สามารถย้อนกลับได้',
    delTitle: 'ยืนยันการลบผู้ใช้งาน {{userName}}',
    delSuccess: `คุณได้ลบผู้ใช้งาน {{userName}} เรียบร้อยแล้ว`,
  },
  user: {
    editUser: 'แก้ไขผู้ใช้งาน',
    addUser: 'เพิ่มผู้ใช้งาน',
    userName: 'ชื่อผู้ใช้',
    email: 'อีเมล',
    time: 'เวลาที่สร้าง',
    role: 'บทบาท',
    outlet: 'ร้านค้า',
    password: 'รหัสผ่าน',
    reset: 'รีเซ็ตรหัสผ่าน',
    good: 'รหัสผ่านที่ดีควรมีทั้งตัวพิมพ์เล็ก ตัวพิมพ์ใหม่ ตัวเลข และต้องมีอย่างน้อย 8 อักขระ',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    required1: `ต้องใส่ชื่อผู้ใช้งาน`,
    required2: `ต้องมีตำแหน่ง`,
    required3: `ต้องใส่ร้านค้า`,
    required4: `ต้องการรหัสผ่าน`,
    select: 'กรุณาเลือก',
    weak: 'รหัสผ่านของคุณง่ายเกินไป กรุณาทำตามข้อกำหนดการตั้งค่ารหัสผ่านที่ยากกว่านี้',
    success: `คุณได้สร้างบัญชีใหม่เรียบร้อยแล้ว`,
    poor: 'แย่',
    medium: 'ปานกลาง',
    good2: 'ดี',
    excellent: 'ดีเยี่ยม',
    tip: `อักขระที่อนุญาตในชื่อผู้ใช้ของคุณคือ: A-Z, a-z, 0-9, '.', '_', '@'.`,
    emailTip: 'โปรดตรวจสอบให้แน่ใจว่าที่อยู่อีเมลนี้ถูกต้อง - เราจะส่งอีเมลไปให้เมื่อคุณลืมรหัสผ่าน',
    emailErrMsg: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
  },
  analytics: {
    all: 'ทั้งหมด',
    analytics: 'การวิเคราะห์',
    period: 'ช่วง',
    frequency: 'ความถี่',
    weekly: 'รายสัปดาห์',
    monthly: 'รายเดือน',
    vs: 'vs. ช่วงก่อนหน้า',
    outlet: 'ร้านค้า',
    allTime: 'ตลอดเวลา',
    last4Weeks: '4 สัปดาห์ที่แล้ว',
    last3Months: '3 เดือนที่แบ้ว',
    weeklyDesc: 'รายสัปดาห์: เริ่มตั้งแต่วันจันทร์',
    monthlyDesc: 'รายเดือน: เริ่มตั้งแต่วันที่ 1',
  },
  charts: {
    order: 'คำสั่งซื้อ',
    total: 'มูลค่าธุรกรรมรวม (รวมคำสั่งซื้อที่คืนเงินแล้ว):',
    totalCount: 'จำนวนคำสั่งซื้อรวม (รวมคำสั่งซื้อที่คืนเงินแล้ว):',
    ave: 'มูลค่าธุรกรรมเฉลี่ย:',
    data: 'จะรวบรวมข้อมูลด้านประชากรตามแต่ละคำสั่งซื้อ',
    cd: 'ข้อมูลด้านประชากรของลูกค้า',
    ot: 'ปริมาณการใช้งานออนไลน์',
    others: 'อื่น ๆ',
    age: 'กลุ่มอายุ',
    majority: 'ส่วนใหญ่',
    type: 'ประเภทบัตร',
    cr: 'บัตรเครดิต',
    dc: 'บัตรเดบิต',
    pc: 'บัตรเติมเงิน',
    gender: 'เพศ',
    female: 'หญิง',
    male: 'ชาย',
    current: 'ปัจจุบัน',
    previous: 'ก่อนหน้า',
    exposure: 'การเปิดรับแสง',
    leads: 'ผู้ที่อาจเป็นลูกค้า',
    weekly: 'รายสัปดาห์',
    hover1: 'กราฟนี้แสดงจำนวนครั้งที่ลูกค้าเห็นร้านค้าของคุณในแอป Atome',
    hover2: 'กราฟนี้แสดงจำนวนครั้งที่ระบบนำลูกค้าจากแอป Atome มายังเว็บไซต์ของคุณ',
    hover1Dec:
      'This chart shows the number of times customers have seen your store in Atome App only from 01 Dec 2020.',
    hover2Dec:
      'This chart shows the number of times customers have seen your store in Atome App only from 01 Dec 2020.',
    count: 'จำนวนการใช้งานบัตรกำนัลที่สนับสนุน',
    amount: 'จำนวนของบัตรกำนัลที่สนับสนุน',
  },
  password: {
    old: 'รหัสผ่านเดิม',
    new: 'รหัสผ่านใหม่',
    retype: 'พิมพ์รหัสผ่านอีกครั้ง',
    change: 'เปลี่ยนรหัสผ่าน',
    tip: 'รหัสผ่านที่ดีควรมีทั้งตัวพิมพ์เล็ก ตัวพิมพ์ใหม่ ตัวเลข และต้องมีอย่างน้อย 8 อักขระ',
    notMatch: 'รหัสผ่านไม่ตรงกัน',
    tooWeak: 'รหัสผ่านของคุณง่ายเกินไป กรุณาทำตามข้อกำหนดการตั้งค่ารหัสผ่านที่ยากกว่านี้',
    notCorrect: 'รหัสผ่านเดิมไม่ถูกต้อง',
    success: 'ตั้งค่ารหัสผ่านเสร็จเรียบร้อยแล้ว',
    poor: 'แย่',
    medium: 'ปานกลาง',
    good2: 'ดี',
    excellent: 'ดีเยี่ยม',
    error: 'ข้อผิดพลาดด้านอินเตอร์เน็ต',
    wrong: 'ขออภัย ชื่อผู้ใช้หรือรหัสผ่านของคุณไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
    receive: 'คุณจะได้รับอีเมลให้ตั้งค่ารหัสผ่านใหม่หากคุณได้ลงทะเบียนไว้กับเรา',
    ops: `ขออภัย...มีข้อผิดพลาดเกิดขึ้น กรุณารีเฟรชและลองอีกครั้ง หรือติดต่อเราที่ {{contactEmail}}`,
    forget: 'ลืมรหัสผ่านหรือไม่?',
    noWorry: 'ไม่ต้องห่วง!',
    userName: 'ชื่อผู้ใช้',
    email: 'อีเมล',
    tip2: 'หากคุณได้ลงทะเบียนบัญชีกับเราโปรดป้อนข้อมูลด้านล่างแล้วเราจะส่งอีเมลไปให้คุณเพื่อรีเซ็ตรหัสผ่านของคุณ',
    invalid: 'Invalid email format',
    your: 'ชื่อผู้ใช้ของคุณ',
    send: 'ส่ง',
    reset: 'ตั้งค่ารหัสผ่านใหม่แล้ว กรุณาล็อกอินอีกครั้ง',
    welcome: 'ยินดีต้อนรับ!',
    needToChange: 'เนื่องจากนี่เป็นการเข้าสู่ระบบครั้งแรกของคุณคุณจะต้องเปลี่ยนรหัสผ่านของคุณ',
  },
  subscription: {
    subscriptionPayout: 'ลงทะเบียนรับรายงานการจ่ายเงินออกทางอีเมล',
    subscriptionTransaction: 'ลงทะเบียนรับรายงานธุรกรรมออกทางอีเมล',
    titlePayout: 'ระบบจะส่งอีเมลที่มีรายงานการชำระเงินของเมื่อวานนี้ไปให้คุณที่เวลา 8 นาฬิกาของทุกวัน',
    titleTransaction: 'ระบบจะส่งอีเมลที่มีรายงานธุรกรรมของเมื่อวานนี้ไปให้คุณที่เวลา 8 นาฬิกาของทุกวัน',
    displayBy: 'บันทึกแสดงโดย',
    recipient: 'ผู้รับ',
    cc: 'cc',
    bcc: 'bcc',
    unsubscribe: 'ยกเลิกการลงทะเบียน',
    confirm: 'ยืนยัน',
    item: 'รายการการชำระเงิน',
    trans: 'ธุรกรรมการชำระเงิน',
    error1: 'รูปแบบอีเมลผู้รับไม่ถูกต้อง กรุณาตรวจสอบและกรอกอีกครั้ง',
    error2: 'รูปแบบอีเมล CC ไม่ถูกต้อง กรุณาตรวจสอบและกรอกอีกครั้ง',
    error3: 'รูปแบบอีเมล BCC ไม่ถูกต้อง กรุณาตรวจสอบและกรอกอีกครั้ง',
    successPayout: `คุณได้ลงทะเบียนรายงานการชำระเงินเรียบร้อยแล้ว`,
    successTransaction: `คุณได้ลงทะเบียนรายงานธุรกรรมเรียบร้อยแล้ว`,
    success2Payout: `คุณยกเลิกการสมัครรายงานการชำระบัญชีสำเร็จแล้ว`,
    success2Transaction: `คุณยกเลิกการสมัครรายงานธุรกรรมบัญชีสำเร็จแล้ว`,
  },
  transaction: {
    detail: 'รายละเอียดธุรกรรม',
    notFound: 'ไม่พบบันทึก',
    refund: 'การคืนเงิน',
    maxAmount: 'จำนวนการคืนเงินสูงสุด',
    refundAmount: 'จำนวนที่คืนเงิน',
    confirm: 'ยืนยัน',
    close: 'ปิด',
    errMsg1: 'การขอคืนเงินของคุณไม่สำเร็จ กรุณาลองอีกครั้งในภายหลัง',
    transId: 'ID ธุรกรรม',
    date: 'วันที่และเวลาของธุรกรรม',
    status: 'สถานะ',
    transAmount: 'จำนวนของธุรกรรม',
    confirmed: 'ยืนยันแล้ว',
    settled: 'จ่ายคืนแล้ว',
    refundStr: 'เรากำลังดำเนินการคืนเงิน {{amount}} บาทที่เวลา {{timeStr}}',
    timeFormat: '{{time}} เมื่อวันที่ {{date}}',
    refundId: 'ID ธุรกรรมการคืนเงิน',
    range: 'ช่วงการคืนเงินที่ใช้ได้',
    to: 'ถึง',
    inclusive: 'รวม',
    amountBreak: 'แยกย่อยจำนวนเงิน',
    amountFee: 'ค่าธรรมเนียมของ Atome:',
    amountFeeVat: 'Atome Fees VAT:',
    amountFeeWht: 'ค่าธรรมเนียม Atome WHT:',
    history: 'ประวัติ',
    wrongParams: 'Atome จะยกเลิกธุรกรรมนี้เนื่องจากค่าพารามิเตอร์ไม่ถูกต้อง หากคุณมีคำถาม กรุณาติดต่อเราที่',
    reversed: 'ธุรกรรมนี้ถูกยกเลิก',
    transactionId: 'ID ธุรกรรม',
    outlet: 'ร้านค้า',
    transactionDate: 'วันที่และเวลาของธุรกรรม',
    transactionAmount: 'จำนวนของธุรกรรม',
    amountReceivable: 'จำนวนที่จะได้รับ',
    transactionType: 'ประเภทธุรกรรม',
    atomeId: 'ID คำสั่งซื้อของ Atome',
    eId: 'ID คำสั่งซื้อบนแพลตฟอร์ม E-commerce',
    voucherAmount: 'จำนวนของบัตรกำนัลที่สนับสนุน',
    adjusted: 'ปรับแล้ว',
    REFUND: 'การคืนเงิน',
    MERCHANDISE: 'สินค้า',
    ADJUSTMENT: 'การปรับจำนวน',
    reversed2: 'ธุรกรรมนี้ถูกยกเลิกแล้ว กรุณาขอการคืนเงินจาก',
    transOutlet: 'ร้านค้าที่ทำธุรกรรม',
    customerName: 'ชื่อลูกค้า',
    phone: 'เบอร์โทรศัพท์',
    reversed3: 'Atome ได้ยกเลิกธุรกรรมนี้ คุณสามารถดูรายละเอียดที่ถูกต้องได้ที่',
    reversed4: '.',
    transactions: 'ธุรกรรม',
    error: 'ขออภัย ไม่สามารถใช้งานเครือข่ายได้ กรุณาลองใหม่อีกครั้งในภายหลัง',
    name: 'ชื่อ',
    createPayment: 'Create payment link',
    transactionStatus: 'สถานะธุรกรรม',
    date2: 'วันที่',
    selectOutlet: 'เลือกร้านค้า',
    mobile: 'โทรศัพท์มือถือ',
    orderId: 'ID คำสั่งซื้อของ Atome',
    eOrderId: 'ID คำสั่งซื้อบนแพลตฟอร์ม E-commerce',
    search: 'ค้นหา',
    export: 'ส่งออก',
    tip: 'ตรวจสอบให้แน่ใจว่าวันเริ่มต้นและวันสิ้นสุดที่เลือกอยู่ภายใน 1 เดือน',
    ALL: 'ทั้งหมด',
    UNSETTLED: 'ยืนยันแล้ว',
    SETTLED: 'จ่ายคืนแล้ว',
    today: 'วันนี้',
    last7: '7 วันที่ผ่านมา',
    last30: '30 วันที่ผ่านมา',
    all: 'ทั้งหมด',
  },
  welcome: {
    change: 'เปลี่ยนรหัสผ่าน',
    welcome: 'ยินดีต้อนรับ!',
    needToAgree: 'เนื่องจากนี่เป็นการเข้าสู่ระบบครั้งแรกของคุณคุณจะต้องยอมรับสัญญาการค้า',
    needToAddEmail: 'เนื่องจากนี่เป็นการเข้าสู่ระบบครั้งแรกของคุณคุณจะต้องป้อนที่อยู่อีเมลและยอมรับสัญญาการค้า',
    needToChange: 'เนื่องจากนี่เป็นการเข้าสู่ระบบครั้งแรกของคุณคุณจะต้องเปลี่ยนรหัสผ่านของคุณ',
    agree: 'ฉันยอมรับ',
    contract: 'สัญญาผู้ค้า',
    ok: 'ตกลง',
    emailExtra: 'โปรดตรวจสอบให้แน่ใจว่าที่อยู่อีเมลนี้ถูกต้อง - เราจะส่งอีเมลไปให้เมื่อคุณลืมรหัสผ่าน',
    emailErrMsg: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
    emailPlaceholder: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
  },
  dashboard: {
    dashboard: 'แดชบอร์ด',
    overview: 'ภาพรวม',
    totalTrans: 'จำนวนรวมของธุรกรรมการซื้อสินค้า',
    totalAmount: 'จำนวนรวมของธุรกรรม',
    totalRefundTrans: 'จำนวนรวมธุรกรรมที่คืนเงิน',
    totalRefundAmount: 'จำนวนรวมการคืนเงิน',
    today: 'วันนี้',
    last7: '7 วันที่ผ่านมา',
    last30: '30 วันที่ผ่านมา',
    all: 'ทั้งหมด',
    transaction: 'ธุรกรรม',
    confirmed: 'ยืนยันแล้ว',
    settled: 'จ่ายคืนแล้ว',
    moreTrans: 'ธุรกรรมเพิ่มเติม',
    activity: 'กิจกรรม',
  },
  company: {
    payments: 'การชำระเงิน',
    payout: 'การจ่ายเงินออก',
    dashboard: 'แดชบอร์ด',
    transactions: 'ธุรกรรม',
    balance: 'ยอดเงิน',
    ana: 'การวิเคราะห์',
    roleMana: 'การจัดการตำแหน่ง',
    userMana: 'การจัดการผู้ใช้งาน',
    help: 'ช่วยเหลือ',
    accountMana: 'การจัดการบัญชี',
  },
  payments: {
    sale: 'ยอดขาย',
    atomeFee: 'ค่าธรรมเนียมของ Atome',
    rebate: 'การคืนเงิน',
    voucher: 'บัตรกำนัลผู้สนับสนุน',
    all: 'ทั้งหมด',
    balance: 'ยอดเงิน',
    outBalance: 'ยอดเงินคงเหลือ',
    outlet: 'ร้านค้า',
    total: 'รวม',
    atomeFeeVAT: 'ภาษีมูลค่าเพิ่มของค่าธรรมเนียม Atome',
    rebateVAT: 'ภาษีมูลค่าเพิ่มของเงินคืน',
    rebateWHT: 'เงินคืน WHT',
    atomeFeeWHT: 'ค่าธรรมเนียม Atome WHT',
    id: 'ID การจ่ายเงินออก',
    detail: 'รายละเอียดการจ่ายเงินออก',
    viewLevel: 'ดูระดับ',
    settlementItem: 'รายการการชำระเงิน',
    settlementItemTip: 'เราแยกย่อยธุรกรรมเป็นแต่ละรายการ เช่น ยอดขาย ค่าธรรมเนียม Atome',
    settlementTran: 'ธุรกรรมการชำระเงิน',
    settlementTranTip: 'จะมีเพียงหนึ่งบันทึกสำหรับแต่ละธุรกรรมในการจ่ายเงินออกไปหนึ่งครั้ง',
    tranId: 'ID ธุรกรรม',
    tranType: 'ประเภทธุรกรรม',
    tranDate: 'วันที่ทำธุรกรรม',
    tranAmount: 'จำนวนของธุรกรรม',
    amountRe: 'จำนวนที่จะได้รับ',
    amountPayout: 'จำนวนที่จ่ายออกไป',
    error: 'ขออภัย ไม่สามารถใช้งานเครือข่ายได้ กรุณาลองใหม่อีกครั้งในภายหลัง',
    summary: 'สรุปรวม',
    export: 'ส่งออก',
    subscription: 'การลงทะเบียน',
    payoutMade: 'เราจ่ายเงินออกจาก Atome ไปยังบัญชีธนาคารของคุณ',
    date: 'วันที่จ่ายเงินออก',
    outletName: 'ชื่อร้านค้า',
    allSettledCount: 'จำนวนธุรกรรมที่จ่ายแล้วทั้งหมด',
    allSettledItemCount: 'จำนวนสินค้าที่จ่ายแล้วทั้งหมด',
    saleCount: 'จำนวนยอดขาย',
    atomeFeeCount: 'จำนวนค่าธรรมเนียม Atome',
    voucherCount: 'จำนวนบัตรกำนัลที่สนับสนุน',
    vatCount: 'การนับภาษีมูลค่าเพิ่มของค่าธรรมเนียม Atome',
    rebateVatCount: 'จำนวนภาษีมูลค่าเพิ่มของเงินคืน',
    whtCount: 'ค่าธรรมเนียม Atome WHT Count',
    rebateWhtCount: 'Rebate WHT Count',
    rebateCount: 'จำนวนการคืนเงิน',
    payoutAmount: 'จำนวนที่จ่ายออกไป',
    payoutStatus: 'สถานะ',
    inTransit: 'อยู่ระหว่างการขนส่ง',
    paid: 'จ่าย',
    payout: 'การจ่ายเงินออก',
    date2: 'วันที่',
    today: 'วันนี้',
    last7: '7 วันที่ผ่านมา',
    last30: '30 วันที่ผ่านมา',
  },
  download: {
    export: 'ส่งออก',
    close: 'ปิด',
    ready: `ส่งออกเรียบร้อยแล้ว หากไม่เห็นไฟล์ของคุณ`,
    preparing: 'เตรียมส่งออก...',
    remaining: 'เหลืออีกไม่กี่วินาที...',
    again: 'ให้ลองดาวน์โหลดอีกครั้ง',
    wrong:
      'เกิดข้อผิดพลาดบางอย่างในการส่งออก ตอนนี้เรา&apos;re กำลังตรวจสอบอยู่ กรุณาลองใหม่อีกครั้งในภายหลัง หรือติดต่อทีมช่วยเหลือของเรา',
  },
  help: {
    help: 'ช่วยเหลือ',
    dashboard: 'แดชบอร์ด',
    h1:
      'คำว่า "ตัวเลขรวมของธุรกรรมสินค้า" "จำนวนรวมของธุรกรรมสินค้า" "ตัวเลขรวมการคืนเงิน" และ "จำนวนรวมการคืนเงิน" หมายความว่าอย่างไร?',
    p1: `แต่ละช่องจะแสดงข้อมูลที่สอดคล้องในช่วงเวลาที่เลือก<br/>
ตัวเลขรวมของธุรกรรมสินค้า: เป็นตัวเลขรวมของธุรกรรมสินค้าที่ซื้อผ่าน Atome (สำหรับบัญชีผู้ขายนี้เท่านั้น)<br/>
จำนวนรวมของธุรกรรมสินค้า: เป็นจำนวนรวมของธุรกรรมสินค้าที่ซื้อผ่าน Atome (สำหรับบัญชีผู้ขายนี้เท่านั้น)<br/>
ตัวเลขรวมการคืนเงิน: ตัวเลขรวมของการคืนเงินที่คืนไปแล้ว (สำหรับบัญชีผู้ขายนี้เท่านั้น)<br/>
จำนวนรวมการคืนเงิน: ตัวเลขรวมของการคืนเงินที่คืนไปแล้ว (สำหรับบัญชีผู้ขายนี้เท่านั้น)<br/>
*โปรดทราบว่า ปัจจุบันยังไม่รองรับการผสานรวมข้อมูลธุรกรรมต่าง ๆ จากทุกสาขา`,
    h2: 'ตาราง "กิจกรรม" จะแสดงอะไร?',
    p2:
      'ตารางกิจกรรมจะแสดงธุรกรรมล่าสุดที่ดำเนินการผ่าน Atome (รวมถึง คำสั่งซื้อที่จ่ายแล้ว คำสั่งซื้อที่ยืนยันแล้ว และคำสั่งซื้อที่คืนเงิน)',
    h3: 'ฉันจะสามารถติดตามคำสั่งซื้อที่ใช้บัตรกำนัล Atome บนแดชบอร์ดของผู้ขายได้หรือไม่?',
    p3: 'ปัจจุบันยังไม่พร้อมใช้งาน',
    transTable: 'ตารางธุรกรรม',
    h4: '"ตัวกรอง" ทำงานอย่างไร?',
    p4: `ฟีเจอร์นี้จะช่วยให้คุณตรวจสอบยอดขายในช่วงเวลาที่เลือกได้ คุณสามารถดูผลลัพธ์ได้โดยเลือกสถานะต่าง ๆ ของคำสั่งซื้อหรือประเภทคำสั่งซื้อ นอกจากนี้ คุณยังสามารถค้นหาคำสั่งซื้อโดยใช้เบอร์โทรศัพท์ของผู้ใช้งานหรือ ID คำสั่งซื้อของ Atome ได้ โปรดทราบว่า ตารางจะแสดงเฉพาะข้อมูลสำหรับช่วงเวลาที่เลือกเท่านั้น`,
    h5: 'แต่ละสถานะมีความหมายอย่างไรบ้าง?',
    p5: `สถานะช่วยให้คุณกรองคำสั่งซื้อที่จ่ายแล้วและคำสั่งซื้อที่ยืนยันแล้วได้<br/>
คำสั่งซื้อที่ยืนยันแล้ว: คือเมื่อเกิดธุรกรรมขึ้น สถานะคำสั่งซื้อจะแสดงเป็น "ยืนยันแล้ว"<br/>
คำสั่งซื้อที่จ่ายเงินแล้ว: เป็นสถานะที่จะแสดงจนถึงเมื่อทีมการเงินได้ชำระเงินเรียบร้อยแล้วเท่านั้น`,
    h6: 'จะใช้ "เบอร์โทรศัพท์" หรือ "ID คำสั่งซื้อ" ค้นหาในแดชบอร์ดธุรกรรมได้อย่างไร?',
    p6: `เบอร์โทรศัพท์คือสิ่งที่ผู้ใช้งานใช้เพื่อลงทะเบียน การใช้เบอร์โทรศัพท์ดังกล่าวเพื่อกรองตัวเลือกจะทำให้คุณเห็นคำสั่งซื้อทั้งหมด (รวมถึง คำสั่งซื้อที่ชำระเงินแล้ว ยืนยันแล้ว หรือมีการคืนเงิน) ที่ผู้ใช้งานนี้ดำเนินการในช่วงเวลาที่คุณเลือก<br/>
ID คำสั่งซื้อควรเป็น ID ธุรกรรมในระบบ Atome และสามารถใช้เพื่อค้นหาแต่ละคำสั่งซื้อได้`,
    h7: 'จะส่งออกข้อมูลเป็นไฟล์ Excel ได้อย่างไร?',
    p7: `คลิกที่ "ส่งออก" เพื่อดาวน์โหลดไฟล์ CSV. สำหรับข้อมูลที่คุณกรองแล้ว คุณสามารถเปิดไฟล์นี้ใน Excel หรือซอฟท์แวร์อื่น ๆ ที่รองรับรูปแบบนี้ได้`,
    companyInfo: 'ข้อมูลบริษัท',
    h8: 'ฉันจะเปลี่ยนแปลงข้อมูลบริษัทได้อย่างไร?',
    p8: `กรุณาติดต่อและแจ้งทีมบริหารจัดการบัญชีของ Atome ถึงเหตุผลที่คุณต้องการเปลี่ยนข้อมูลบริษัท เมื่อได้รับการยืนยันแล้ว ทีมงานจะช่วยคุณเปลี่ยนข้อมูลใน xx วันทำการ`,
    h9: 'มีข้อจำกัดสำหรับจำนวนครั้งในการเปลี่ยนข้อมูลบริษัทหรือไม่?',
    p9: `ไม่มี เราไม่มีข้อจำกัดในเรื่องนี้ แต่กรุณาแจ้งเหตุผลที่คุณต้องการเปลี่ยนข้อมูลให้ทีมเราทราบเมื่อคุณต้องการเปลี่ยนข้อมูล`,
    account: 'บัญชีและรหัสผ่าน',
    h10: 'ชื่อผู้ใช้งานและรหัสผ่านเริ่มต้นของฉันคืออะไร?',
    p10:
      'ชื่อผู้ใช้งานและรหัสผ่านเริ่มต้นจะอยู่ในอีเมลที่ส่งหาคุณเพื่อเริ่มใช้งานระบบ หากมีความไม่ถูกต้องใด กรุณาติดต่อผู้จัดการบัญชีของเราทันที',
    h11: 'ถ้าฉันลืมรหัสผ่าน จะต้องทำอย่างไร?',
    p11: `สามารถตั้งค่ารหัสผ่านใหม่ผ่านทางอีเมลได้<br/>
คลิกที่ "Forget password" ที่หน้าล็อกอิน และตรวจสอบอีเมลของคุณ ระบบจะส่งอีเมลที่มีลิงก์สำหรับตั้งค่ารหัสผ่านใหม่ไปยังกล่องอีเมลของคุณในระยะเวลาอันสั้น<br/>
หากคุณไม่สามารถเริ่มต้นใช้งานระบบได้ด้วยอีเมลใด ๆ กรุณาติดต่อผู้จัดการบัญชีของคุณโดยตรงเพื่อตั้งค่ารหัสผ่านใหม่`,
    h12: 'จะเปลี่ยนรหัสผ่าน/ตั้งค่ารหัสผ่านใหม่อย่างไร?',
    p12: `ใส่ "โพรไฟล์" และคลิก "เปลี่ยนรหัสผ่าน" รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านเดิม<br/>
รหัสผ่านที่ดีควรมีทั้งตัวพิมพ์เล็ก ตัวพิมพ์ใหม่ ตัวเลข และต้องมีอย่างน้อย 8 อักขระ`,
    h13: 'มีข้อจำกัดสำหรับจำนวนครั้งในการเปลี่ยนรหัสผ่านหรือไม่?',
    p13: `ไม่มี เราไม่มีข้อจำกัดในเรื่องนี้`,
    h14: 'ฉันสามารถตั้งหลายรหัสผ่านสำหรับแต่ละบัญชีสาขาได้หรือไม่?',
    p14: `ได้ คุณตั้งได้ สำหรับรายละเอียดเพิ่มเติม กรุณาติดต่อผู้จัดการบัญชีของคุณเพื่อดำเนินการตั้งค่าหลายรหัสผ่านให้แล้วเสร็จ`,
    refund: 'การคืนเงิน',
    h15: 'หากฉันเริ่มการคืนเงิน ฉันจะได้ค่าคอมมิชชั่นที่ Atome เรียกเก็บคืนมาหรือไม่? ก่อนหรือหลังการคืนเงิน?',
    p15: 'ค่าคอมมิชชั่นที่ Atome เรียกเก็บจะส่งกลับไปยังบัญชีของคุณหลังการคืนเงินแล้ว',
    h16: 'ฉันสามารถเริ่มการคืนเงินจากบัตรหลักได้หรือไม่?',
    p16: `ได้ คุณสามารถคืนเงินจากบัญชี "ผู้จัดการร้าน" หรือบัญชี "ผู้ดูแลระบบบริษัท" หรือบัญชีอื่น ๆ ที่บริษัทของคุณสร้างขึ้นที่มีการอนุญาต "การคืนเงิน" ได้`,
    h17: `หากฉันเป็นร้านค้าออนไลน์ การคืนเงินที่ดำเนินการผ่านแพลตฟอร์มบุคคลที่สามจะรวมเข้ากับศูนย์ผู้ขายของ Atome หรือไม่?`,
    p17: `ใช่ การคืนเงินทั้งหมดที่ดำเนินการผ่านแพลตฟอร์มบุคคลที่สามจะผสานรวมเข้ากับศูนย์รวมผู้ขายของ Atome แต่โปรดทราบว่าอาจมีความล้าช้าของข้อมูลเล็กน้อย<br/>
อย่างไรก็ตาม โปรดทราบว่าการคืนเงินผ่านศูนย์ผู้ขายของ Atome จะไม่แสดงบนแพลตฟอร์มบุคคลที่สาม`,
    needHelp: 'ไม่พบคำตอบสำหรับคำถามของคุณ? เรายินดีช่วยเหลือคุณเสมอ',
    reach: 'กรุณาติดต่อเราที่',
    reach2: '',
  },
};
